export const WordCount = (str) => {
  return str.split(' ').length;
};
